import { TextLabel } from '@core/components/Inputs';
import { formatCNPJ } from '@format';
import { Grid } from '@material-ui/core';
import React from 'react';

function DadosGeraisPanel({ transportadora }) {
  const { pessoa = {} } = transportadora;

  const optionsIndicador = [
    { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
    { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS ' },
    { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
  ];

  const indicadorValue =
    pessoa?.pessoaJuridica?.indicadorInscricaoEstadual &&
    optionsIndicador.find((op) => op.id === pessoa.pessoaJuridica.indicadorInscricaoEstadual).title;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.nome" label="Nome" value={pessoa?.nome} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          label="CNPJ"
          id="pessoa.pessoaJuridica.cnpj"
          value={pessoa?.pessoaJuridica?.cnpj}
          format={formatCNPJ}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          label="Indicador de inscrição estadual"
          id="pessoa.pessoaJuridica.indicadorInscricaoEstadual"
          value={indicadorValue}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          id="pessoa.pessoaJuridica.inscricaoEstadual"
          label="Inscrição estadual"
          value={pessoa?.pessoaJuridica?.inscricaoEstadual}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.inscricaoMunicipal" label="Inscrição municipal" value={pessoa?.inscricaoMunicipal} />
      </Grid>
    </Grid>
  );
}

export default DadosGeraisPanel;
